/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ gb: NonNullable<unknown> }} Embed_Captions_Confirm_Storage_LabelInputs */



/**
* | output |
* | --- |
* | "Storage ({gb} GB):" |
*
* @param {Embed_Captions_Confirm_Storage_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_confirm_storage_label = /** @type {((inputs: Embed_Captions_Confirm_Storage_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Confirm_Storage_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Stockage (${i?.gb} Go) :`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Speicherplatz (${i?.gb} GB):`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Archiviazione (${i?.gb} GB):`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Объем памяти (${i?.gb} ГБ):`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Almacenamiento (${i?.gb} GB):`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`存储空间（${i?.gb} GB）：`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ストレージ (${i?.gb} GB):`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`भंडारण (${i?.gb} जीबी):`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Armazenamento (${i?.gb} GB):`)
	return /** @type {LocalizedString} */ (`Storage (${i?.gb} GB):`)
});